import "core-js/modules/es.iterator.constructor.js";
import "core-js/modules/es.iterator.map.js";
import { uploadFile } from '../request';
import { getBase64, isImage, isVideo, isPDF } from '@/views/claim/demageManage/utils';
const MAX_SIZE = 50; // MB
const MAX_VIDEO_SIZE = 300; // MB
export default {
  props: {
    item: {
      type: Object,
      default: () => {}
    },
    formData: {
      type: Object,
      default: () => {}
    },
    rulesTrue: {
      type: Object,
      default: () => {}
    },
    index: {
      type: Number,
      default: 0
    },
    formDataArray: {
      type: Array,
      default: () => []
    }
  },
  data() {
    return {
      action: uploadFile
    };
  },
  computed: {},
  methods: {
    // 单选
    onChangeFormat(index) {
      this.toChangeUploadAccept(this.formDataArray[index].fileFormat);
      console.log('获取文件-------格式----', this.formDataArray[index].fileFormat);
    },
    // 结束
    // 设置上传文件限制格式
    toChangeUploadAccept(data) {
      console.log(data, '设置上传文件限制格式');
      if (data.length) {
        data = data.map(i => '.' + i);
        this.uploadAccept = data.join(',');
      } else {
        this.uploadAccept = 'image/*';
      }
    },
    // 当输入框被清空时，parseInt() 函数会返回 NaN（Not a Number），
    handleInputBlur(fileNumber) {
      if (!fileNumber.value || isNaN(fileNumber.value)) {
        fileNumber.value = 10; // 设置默认值为 2 或其他合适的值
      }
    },
    formatInteger(value) {
      return value ? String(parseInt(value)) : '';
    },
    // 设置上传文件限制格式
    toChangeUploadAccept(data) {
      console.log(data, '设置上传文件限制格式');
      if (data.length) {
        data = data.map(i => '.' + i);
        this.uploadAccept = data.join(',');
      } else {
        this.uploadAccept = 'image/*';
      }
    },
    isFileSizeValid(file, maxSize) {
      return file.size / 1024 / 1024 < maxSize;
    },
    // 文件上传逻辑
    clickPlusTWO(index) {
      this.indexQJ = index;
      // 文件的类型的数据
      // if (this.formDataArray[index].fileFormat.length == 0) {
      //   this.$message.error(this.$t('请选择文件格式'));
      //   return;
      // }
    },
    changeUploadTwo({
      file,
      fileList
    }) {
      // 定义一个全局的index
      const index = this.indexQJ;
      // if (this.formDataArray[index].fileFormat.length == 0) {
      //   this.$message.error(this.$t('请选择文件格式'));
      //   return;
      // }
      const isVideoFile = isVideo(file.name);
      const maxSize = isVideoFile ? MAX_VIDEO_SIZE : MAX_SIZE;
      if (!this.isFileSizeValid(file, maxSize)) {
        const errorMessage = this.$t(isVideoFile ? '视频最大不超300M' : '文件最大不超50M');
        this.$message.error(errorMessage);
        return;
      }
      const fileType = file.name.substring(file.name.lastIndexOf('.')).substring(1);
      // 文件类型
      if (!this.formDataArray[index].fileFormat.includes(fileType)) {
        this.$message.error(this.$t('文件格式错误'));
        return;
      }
      // 文件列表
      this.formDataArray[index].fileListData = fileList.map(item => {
        if (item.response && item.response.code === 200 && item.status === 'done') {
          item.url = process.env.NODE_ENV === 'production' ? cryptoDecrypt(item.response.data).fileTempUrl : item.response.data.fileTempUrl;
          // 将文件URL添加到templateUrl变量中
          this.formDataArray[index].templateUrl += item.url + ',';
        }
        return item;
      });
      // 移除最后一个逗号
      this.formDataArray[index].templateUrl = this.formDataArray[index].templateUrl.slice(0, -1);
      this.showActionButtons = true;
    },
    async handlePreview(file) {
      this.isShow = '';
      if (isImage(file.name)) {
        this.isShow = 'image';
      }
      if (isVideo(file.name)) {
        this.isShow = 'video';
      }
      this.isPDFShow = isPDF(file.name);
      if (!file.url && !file.preview) {
        file.preview = await getBase64(file.originFileObj);
      }
      if (this.isShow === 'image' || this.isShow === 'video') {
        this.previewSrc = file.url || file.preview;
        this.currentPreviewIndex = this.dataForm.template.indexOf(file);
      } else if (this.isPDFShow) {
        this.previewPDF = file.url || file.response.data.fileTempUrl;
        window.open(this.previewPDF);
        return;
      } else {
        window.open(file.url || file.response.data.fileTempUrl);
        return;
      }
      this.previewVisible = true;
    },
    // 附件上传新建
    beforeUpload(file) {
      const index = this.indexQJ;
      if (this.formDataArray[index].fileFormat.length < 0) {
        this.$message.error('请选择文件格式');
        return;
      }
      const extension = file.name.split('.').pop().toLowerCase();
      // "fileFormat": "文件格式：Word Xlsx xls JPG mov jpeg mp4 PDF BMP docx doc rm rmvb avi jpg
      const isValidType = this.formDataArray[index].fileFormat.includes(extension);
      if (!isValidType) {
        this.$message.error(this.$t('无效的文件格式'));
      }
      const isValidSize = file.size / (this.formDataArray[index].fileSize.type === 'MB' ? 1024 * 1024 : 1024) < this.formDataArray[index].fileSize.size;
      if (!isValidSize) {
        this.$message.error(this.$t('文件大小超过限制'));
      }
      return isValidType && isValidSize;
    },
    // 关闭事件
    formeClase(index) {
      this.formDataArray[index].editing = false;
    }
  }
};